<template>
  <div v-bind:class="{ flipToggle: true, active: active }" id="filter">
    <div class="inner">
      <div
        v-on:click="clear"
        v-bind:class="{
          clearFilter: true,
          button: true,
          adapted: true,
          tiny: true,
          disabled: !filterIsActive,
        }"
      >
        {{ $t("clearFilter") }}
      </div>
      <!-- clearFilter -->

      <div v-on:click="close" class="close">
        <i class="icon-close"></i>
      </div>

      <div class="search">
        <div class="icon"><i class="fa fa-search"></i></div>
        <input class="mobileInput" v-model="search" type="text" />
      </div>

        <div class="filterOptions">
            <div
                class="filterOption"
                v-if="useThisFilter(filterItem)"
                :key="filterItem.id"
                v-for="filterItem in filters">

                <div class="filterOption bold">{{ filterItem.title }}</div>

                <div
                @click="pickFilter(item)"
                :key="item.id"
                v-for="item in filterItem.items"
                :class="{ filterItem: true, disabled: item.numberOfProducts == 0 , active: checkActiveItem(item.id) }"
                >
                {{ item.title }}

                <!-- Colors -->
                <div
                    class="colorItem"
                    :style="getColor(item.systemCode)"
                    v-if="filterItem.id == 1"
                ></div>

                </div>
            </div> <!-- filterOption -->
        </div> <!-- filterOptions -->
    </div>
    <!-- inner -->
  </div>
  <!-- filter -->
</template>

<script>
export default {
  data: function () {
    return {
      search: "",
      expanded: {},
    };
  },

  watch: {
    // whenever search changes this function will run
    search: function (newSearch) {
      this.getSearch();
    },
  },

  computed: {
    active() {
      return this.$store.state.articleFilterActive;
    },

    filters() {
      return this.$store.state.articleFilter;
    },

    chosenFilters() {
      return this.$store.state.chosenArticleFilter;
    },

    articleFilterAvailable() {
      return this.$store.state.articleFilterAvailable;
    },

    filterIsActive() {
      return false;
    },
  },

  methods: {
    getSearch: _.debounce(
      function () {
        var self = this;
        window.eventHub.$emit("searchUpdated", self.search);
      },
      300 // time
    ),

    getColor(color) {

        var style = "";

        switch (color) {
            case 'purple':
                style = "rgb(122, 35, 143)" 
                break;
            case 'multi':
                style = "linear-gradient(135deg, rgb(203, 138, 19) 0%, rgb(233, 249, 138) 50%, rgb(118, 187, 184) 100%)" 
                break;
            case 'brown':
                style = "rgb(116, 63, 37)" 
                break;
            case 'orange':
                style = "rgb(243, 122, 41)" 
                break;
            case 'copper':
                style = "linear-gradient(135deg, rgb(142, 68, 50) 0%, rgb(229, 166, 137) 40%, rgb(229, 166, 137) 50%, rgb(229, 166, 137) 60%, rgb(142, 68, 50) 100%)"
                break;
            
            case 'silver':
                style = "linear-gradient(135deg, rgb(161, 167, 171) 0%, rgb(221, 222, 224) 40%, rgb(221, 222, 224) 50%, rgb(221, 222, 224) 60%, rgb(161, 167, 171) 100%)"
                break;

            case 'beige':
                style = "rgb(232, 212, 193)"
                break;
            case 'gold':
                style = "linear-gradient(135deg, rgb(183, 160, 78) 0%, rgb(246, 220, 153) 40%, rgb(246, 220, 153) 50%, rgb(246, 220, 153) 60%, rgb(183, 160, 78) 100%)" 
                break;
            case 'blackAndWhite':
                style = "linear-gradient(135deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 50%, rgb(255, 255, 255) 50%, rgb(255, 255, 255) 100%)" 
                break;
            case 'blue':
                style = "rgb(15, 91, 153)" 
                break;
            case 'turquoise':
                style = "rgb(18, 235, 200)" 
                break;
            case 'black':
                style = "rgb(0, 0, 0)" 
                break;
            case 'green':
                style = "rgb(101, 165, 80)" 
                break;
            case 'gray':
                style = "rgb(218, 218, 218)" 
                break;
            case 'red':
                style = "rgb(179, 35, 18)" 
                break;
            case 'yellow':
                style = "rgb(245, 223, 12)" 
                break;
            case 'red':
                style = "rgb(179, 35, 18)" 
                break;
            case 'white':
                style = "rgb(255, 255, 255); border: 1px solid #dcd9d9;" 
                break;
            case 'pink':
                style = "rgb(252, 196, 200)" 
                break;
        }

        return "background: " + style;

    },

    pickFilter: function (filterItem) {
      this.$store.commit("toggleChosenArticleFilter", filterItem);
      window.eventHub.$emit("filterUpdated");
    },

    checkActiveItem(id) {
      var found = false;

      if (typeof this.chosenFilters !== "undefined")
        $.each(this.chosenFilters, function (index, value) {
          if (value.id == id) found = true;
        });

      return found;
    },

    useThisFilter(filter) {
      switch (filter.id) {
        case 1:
        case 4:
        case 5:
          return true;
          break;
        default:
          return false;
      }
    },

    close() {
      this.$store.commit("articleFilterActive", false);
    },

    clear: function () {
      this.search = "";
      this.$store.commit("chosenArticleFilter", {});
      window.eventHub.$emit("filterUpdated");
    },

    toggleExpand(item) {
      if (this.expanded[item.id]) {
        this.$set(this.expanded, item.id, false);
      } else {
        this.$set(this.expanded, item.id, true);
      }
    },
  },

  mounted() {
    var self = this;

    // When this is opened
    window.eventHub.$on("toggleArticleFilter", function (data) {
      window.eventHub.$emit("closeRightMenus", "all");
      var newState = !self.active;
      self.$store.commit("articleFilterActive", newState);
    });

    // Close picker event
    window.eventHub.$on("closeArticleFilter", function (type) {
      self.$store.commit("articleFilterActive", false);
    });

    // Close picker event
    window.eventHub.$on("clearSearch", function (type) {
      self.search = "";
    });

    // When remove a single filter
    window.eventHub.$on("removeFilterChoice", function (filterItem) {
      self.pickFilter(filterItem);
    });
  },
};
</script>

<style>
    #filter {
        width: 300px;
        background: white;
        left: 0px;
        height: calc(100% - 51px);
        background: white;
        z-index: 2;
        padding: 15px;
        overflow: auto;
        border-top: 1px solid #eaeaea;

        /* Mobile */
        @media screen and (max-width: 812px) {
            height: calc(100% - 45px);
            top: 0px;
            width: 210px;
            border-bottom: 1px solid #eaeaea;
        }

        .close {
            position: absolute;
            right: 0;
            top: 0;
            padding: 5px 11px;
            font-size: 21px;
            cursor: pointer;
        }

        .inner {
            height: 100%;
        }

        .search {
            z-index: 999;
            position: relative;
            float: left;
            width: calc(100%);

            .icon {
                position: absolute;
                margin-top: 8px;
                color: #d6d6d6;
                margin-left: 10px;

                /* Mobile */
                @media screen and (max-width: 812px) {
                    margin-top: 1px;
                    color: #d6d6d6;
                    margin-left: 7px;
                }
            }

            input {
                font-size: 14px;
                width: 100%;
                border: 0px;
                border: 1px solid #eaeaea;
                margin: 0;
                height: 43px;
                margin-bottom: 14px;
                padding-left: 40px;

                /* Mobile */
                @media screen and (max-width: 812px) {
                    height: 30px;
                    padding-left: 30px;
                }
            }
        }

        .colorItem{
            padding: 8px;
            float: left;
            margin-top: 3px;
            margin-right: 5px;
        }

        .clearFilter {
            margin-bottom: 15px;

            &.disabled {
                opacity: 0.4;
                pointer-events: none;
            }
        }

        .filterOptions{
            height: calc(100% - 122px);
            float: left;
            width: 100%;
            clear: both;
            overflow: scroll;

             /* Mobile */
            @media screen and (max-width: 812px) {
                height: calc(100% - 80px) !important;
            }
        }

        .filterOption {
            float: left;
            width: 100%;
            margin-bottom: 10px;
        }

        .filterItem {
            float: left;
            padding: 5px 10px;
            border: 1px solid black;
            margin-right: 7px;
            margin-bottom: 10px;
            font-size: 14px;
            border-radius: 4px;
            cursor: pointer;

            &.disabled {
                opacity: 0.3;
                pointer-events: none;
            }

            &.active {
                background: black;
                color: white;
            }

            &:hover {
                opacity: 0.5;
            }
        }

        label {
            margin: 0px;
            font-size: 12px;
            font-weight: normal;
            text-transform: uppercase;
            float: left;
            cursor: pointer;
        }

        /* Toggleable filter container */
        .toggleAble {
            position: relative;
            float: left;
            width: 100%;
            padding-bottom: 34px;
            height: 225px;
            overflow: hidden;

            .showMore {
                position: absolute;
                margin-top: 0px;
                background: white;
            }
        }

        /* Show more button */
        .showMore {
            float: left;
            width: 100%;
            bottom: 0px;
            padding: 10px 0;
            font-size: 14px;
            text-decoration: underline;
            cursor: pointer;
            margin-top: -5px;
        }
    }
</style>



// WEBPACK FOOTER //
// ArticleFilterWG.vue?048347e7